import { Model } from "pinia-orm";

export default class Analysis extends Model {
  static entity = "analyses";
  static primaryKey = "uuid";

  static fields() {
    return {
      uuid: this.uid(""),
      name: this.string(""),
      code: this.attr(null),
      analysisType: this.attr(null),
      price: this.attr(null),
      isArchived: this.attr(null),
      quotationCode: this.attr(null),
    };
  }
}
